<!-- UNIVAPLAT-3693: delete organisation modal (role/aria-modal/focus trap come from NgbModal) -->
<div class="modal-header">
    <h1 class="modal-title fs-5 fw-normal" id="delete-organisation-title" data-testid="delete-organisation-title">Confirm the action</h1>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(false)"
            data-testid="delete-organisation-close"></button>
</div>
<div class="modal-body">
    <p data-testid="delete-organisation-description">Are you sure you want to delete this organisation?</p>
    <p>The organisation is kept in the database but cannot be restored or edited. Its code is freed so it can be reused.</p>
    <label for="delete-organisation-reason" class="form-label">Reason (optional)</label>
    <textarea id="delete-organisation-reason" class="form-control" rows="3"
              [formControl]="reason"
              [class.is-invalid]="reason.invalid"
              [attr.aria-invalid]="reason.invalid"
              aria-describedby="delete-organisation-reason-hint delete-organisation-reason-error"
              data-testid="delete-organisation-reason"></textarea>
    <div id="delete-organisation-reason-hint" class="form-text" role="status" aria-live="polite">{{ length }} / {{ maxLength }} characters</div>
    <div id="delete-organisation-reason-error" aria-live="polite">
        @if (reason.errors?.['maxlength']) {
            <div class="invalid-feedback d-block" data-testid="delete-organisation-reason-error">
                The reason must be {{ maxLength }} characters or fewer.
            </div>
        }
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-gray text-dark" (click)="modal.dismiss(false)"
            data-testid="delete-organisation-cancel">No, cancel</button>
    <button type="button" class="btn btn-outline-danger"
            [disabled]="saving || reason.invalid"
            [attr.aria-busy]="saving"
            (click)="submit()"
            data-testid="delete-organisation-submit">
        Yes, proceed
    </button>
</div>
